/* CAVEAT: if File transfers are involved, don't use this function, blobs and files would be transformed into simple objects */
export const stripTypename = <T extends object>(data: T): T =>
  JSON.parse(
    JSON.stringify(data, (key, value: unknown) =>
      key === '__typename' ? undefined : value,
    ),
  ) as T;
